const options = {
  5: "bg-amber-500/5",
  10: "bg-amber-500/10",
  25: "bg-amber-500/25",
  50: "bg-amber-500/50",
  75: "bg-amber-500/75",
  90: "bg-amber-500/90",
  100: "bg-amber-500",
};

const from = {
  5: "from-amber-500/5",
  10: "from-amber-500/10",
  25: "from-amber-500/25",
  50: "from-amber-500/50",
  75: "from-amber-500/75",
  90: "from-amber-500/90",
  100: "from-amber-500",
};

export default function getBackgroundAmber500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
